/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { GetOraganisationDetails, GetOraganisationList } from '../../../../redux/action';
import style from '../../../../assets/styles/userManagement.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { Pagination } from '../../common/Pagination';
import { useNavigate } from 'react-router-dom';
import FilterModal from './FilterModel';
const OrganisationList = () => {
  //--------------------------------Old start--------------------------------//
  // ________ filter modal open  ________
  const [modalFilter, setModalFilter] = useState(false);

  //_________  redux api call _________
  const { orgList } = useSelector((state) => state.GetAllData);
  const [keyword, setKeyword] = useState(null);
  const [sort, setSort] = useState('');
  const [sortStatus, setSortStatus] = useState(true);
  const [sortOrganisation, setSortOrganisation] = useState(true);
  const [sortOrgName, setSortOrgName] = useState(true);
  const [sortUserRole, setSortUserRole] = useState(true);
  const [sortStatusIcon, setSortStatusIcon] = useState(false);
  const [sortOrganisationIcon, setSortOrganisationIcon] = useState(false);
  const [sortOrgIcon, setSortOrgIcon] = useState(false);
  const [sortQuestionIcon, setSortQuestionIcon] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [last, setLast] = useState(5);
  const limit = 15;
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [inputPage, setInputPage] = useState(currentPage);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [statusValue, setStatusValue] = useState(null);
  const [filterValue, setFilterValue] = useState('');
  //-----------------------------Methods-----------------------------------//
  useEffect(() => {
    if (currentPage && currentPage > 0) {
      setIsLoading(true);
      dispatch(GetOraganisationList(keyword, sort, limit, currentPage, filterValue));
    }
    setModalFilter(false);
  }, [keyword, sortOrganisation, sort, currentPage, filterValue]);

  useEffect(() => {
    setIsLoading(true);
    setCurrentPage(1);
    setInputPage(1);
    setOffset(0);
    setFilterValue('');
    return () => {
      dispatch(GetOraganisationList('', '', '', ''));
    };
  }, []);

  useEffect(() => {
    if (orgList) {
      setIsLoading(false);
      const totalResults = orgList.count;
      // If the current offset is greater than the total results,
      // reset to first page
      if (offset >= totalResults && totalResults > 0) {
        setOffset(0);
        setCurrentPage(1);
        setInputPage(1);
        setLast(Math.min(15, orgList?.count));
        setTotalCount(offset);
      } else {
        if (orgList?.count) {
          setTotalCount(orgList?.count);
          setLast(Math.min(offset + 15, orgList?.count));
        }
        if (!orgList?.count) {
          setTotalCount(0);
          setLast(1);
          setOffset(0);
        }
      }
    }
  }, [orgList]);

  const sortUserFunction = () => {
    setSortOrganisationIcon(true);
    setSortOrgIcon(false);
    setSortQuestionIcon(false);
    setSortStatusIcon(false);

    if (sortOrganisation) {
      setSort('no_of_users');
      setSortOrganisation(!sortOrganisation);
    } else {
      setSort('-no_of_users');
      setSortOrganisation(!sortOrganisation);
    }
  };

  const sortOrgNameFunction = () => {
    setSortOrgIcon(true);
    setSortOrganisationIcon(false);
    setSortQuestionIcon(false);
    setSortStatusIcon(false);
    if (sortOrgName) {
      setSort('name');
      setSortOrgName(!sortOrgName);
    } else {
      setSort('-name');
      setSortOrgName(!sortOrgName);
    }
  };

  const sortQuestionsFunction = () => {
    setSortQuestionIcon(true);
    setSortOrganisationIcon(false);
    setSortOrgIcon(false);
    setSortStatusIcon(false);
    if (sortUserRole) {
      setSort('no_of_questions');
      setSortUserRole(!sortUserRole);
    } else {
      setSort('-no_of_questions');
      setSortUserRole(!sortUserRole);
    }
  };

  const sortStatusFunction = (type) => {
    if (sortStatus) {
      setSort('is_active');
      setSortStatus(!sortStatus);
      setSortStatusIcon(true);
    } else {
      setSort('-is_active');
      setSortStatus(!sortStatus);
      setSortStatusIcon(true);
    }

    setSortOrganisationIcon(false);
    setSortOrgIcon(false);
    setSortQuestionIcon(false);
  };
  const handleFilter = (item) => {
    setFilterValue(item.toLowerCase());
    setCurrentPage(1);
    setInputPage(1);
  };
  const handleSreach = (e) => {
    setKeyword(e.target.value);
    setCurrentPage(1);
    setInputPage(1);
    setSortOrganisation(false);
    setSortStatus(false);
    setSort('');
    setSortOrganisationIcon(false);
    setSortOrgIcon(false);
    setSortQuestionIcon(false);
    setSortStatusIcon(false);
  };

  const getRotation = (column) => {
    if (sort === column) {
      return 'rotate(180deg)';
    }
    return 'rotate(0deg)';
  };

  return (
    <div>
      <div className={style.question_bank}>
        {/* TABLE SECTION OF THIS PAGE  */}
        <div className={`${style.table_content_report} ${style.user_table_content}`}>
          {/* _______________________Top content of table_______________________  */}
          <div className={style.top_content_table}>
            {/*_______________________  Search bar  _______________________ */}
            <div className={` ${style.search_listing} ${style.user_management_search_listing}`}>
              <div className={style.tag_icon}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.5 18C15.0899 18 18 15.0899 18 11.5C18 7.91015 15.0899 5 11.5 5C7.91015 5 5 7.91015 5 11.5C5 15.0899 7.91015 18 11.5 18Z"
                    stroke="#212529"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M18.2598 19.2592L16.1406 16.8594"
                    stroke="#212529"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className={style.input_search}>
                <input
                  type="search"
                  id="searchInput"
                  placeholder="Search by organization name and organization admin"
                  onChange={(e) => {
                    handleSreach(e);
                  }}
                />
              </div>
            </div>
            {/*_______________________  filter  _______________________ */}
            <div className={`${style.filter} ${style.orgFilter}`}>
              <div
                className={style.pointer}
                onClick={() => {
                  setModalFilter(true);
                }}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill={filterValue ? '#00ABFB' : 'none'}
                    d="M5.39844 2.10156H18.5984C19.6984 2.10156 20.5984 3.00156 20.5984 4.10156V6.30156C20.5984 7.10156 20.0984 8.10156 19.5984 8.60156L15.2984 12.4016C14.6984 12.9016 14.2984 13.9016 14.2984 14.7016V19.0016C14.2984 19.6016 13.8984 20.4016 13.3984 20.7016L11.9984 21.6016C10.6984 22.4016 8.89844 21.5016 8.89844 19.9016V14.6016C8.89844 13.9016 8.49844 13.0016 8.09844 12.5016L4.29844 8.50156C3.79844 8.00156 3.39844 7.10156 3.39844 6.50156V4.20156C3.39844 3.00156 4.29844 2.10156 5.39844 2.10156Z"
                    stroke="#212529"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>

                <span>Filter by</span>
              </div>
            </div>
            {/*_______________________  Add Question Button  _______________________ */}
            <div className={style.add_question}>
              <button
                className={` ${style.add_new_question} ${style.pointer} ${style.OrgButton}`}
                onClick={() => navigate('/organization-management/add')}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" fill="white" />
                  <path
                    d="M7.5 12H16.5"
                    stroke="#00ABFB"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 16.5V7.5"
                    stroke="#00ABFB"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span>Add Organization</span>
              </button>
            </div>
          </div>

          {/* TABLE LISTING OF USERS  */}
          {totalCount !== 0 ? (
            <div className={`${style.sub_head_content_table} ${style.sub_head_content_table_new}`}>
              <table>
                <thead>
                  <tr>
                    <th className={` ${style.first} ${style.pointer}`} onClick={() => sortOrgNameFunction()}>
                      <span>Organization</span>
                      <svg
                        width="19"
                        height="12"
                        viewBox="0 0 19 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          marginLeft: '6px',
                          transform: getRotation('-name'),
                          transition: 'transform 0.3s ease',
                        }}
                      >
                        <path
                          d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                          fill={sortOrgIcon ? '#00ABFB' : '#999090'}
                        />
                        <path
                          d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                          fill={sortOrgIcon ? '#00ABFB' : '#999090'}
                        />
                        <path
                          d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                          fill={sortOrgIcon ? '#00ABFB' : '#999090'}
                        />
                        <path
                          d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                          fill={sortOrgIcon ? '#00ABFB' : '#999090'}
                        />
                      </svg>
                    </th>
                    <th colSpan="" className={` ${style.first} ${style.pointer} ${style.orgadmin_col_width}`}>
                      <span>Organization Admin</span>
                    </th>
                    <th className={` ${style.second} ${style.pointer}`} onClick={() => sortUserFunction()}>
                      <span>No. of Users</span>
                      <svg
                        width="19"
                        height="12"
                        viewBox="0 0 19 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          marginLeft: '6px',
                          transform: getRotation('-no_of_users'),
                          transition: 'transform 0.3s ease',
                        }}
                      >
                        <path
                          d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                          fill={sortOrganisationIcon ? '#00ABFB' : '#999090'}
                        />
                        <path
                          d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                          fill={sortOrganisationIcon ? '#00ABFB' : '#999090'}
                        />
                        <path
                          d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                          fill={sortOrganisationIcon ? '#00ABFB' : '#999090'}
                        />
                        <path
                          d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                          fill={sortOrganisationIcon ? '#00ABFB' : '#999090'}
                        />
                      </svg>
                    </th>
                    <th className={` ${style.second} ${style.pointer}`} onClick={() => sortQuestionsFunction()}>
                      <span>No. of Questions</span>
                      <svg
                        width="19"
                        height="12"
                        viewBox="0 0 19 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          marginLeft: '6px',
                          transform: getRotation('-no_of_questions'),
                          transition: 'transform 0.3s ease',
                        }}
                      >
                        <path
                          d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                          fill={sortQuestionIcon ? '#00ABFB' : '#999090'}
                        />
                        <path
                          d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                          fill={sortQuestionIcon ? '#00ABFB' : '#999090'}
                        />
                        <path
                          d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                          fill={sortQuestionIcon ? '#00ABFB' : '#999090'}
                        />
                        <path
                          d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                          fill={sortQuestionIcon ? '#00ABFB' : '#999090'}
                        />
                      </svg>
                    </th>

                    <th
                      className={` ${style.fifth} ${style.pointer}`}
                      onClick={() => !statusValue && sortStatusFunction()}
                    >
                      <span>Status</span>
                      <svg
                        width="19"
                        height="12"
                        viewBox="0 0 19 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          marginLeft: '6px',
                          transform: getRotation('-is_active'),
                          transition: 'transform 0.3s ease',
                        }}
                      >
                        <path
                          d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                          fill={sortStatusIcon ? '#00ABFB' : '#999090'}
                        />
                        <path
                          d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                          fill={sortStatusIcon ? '#00ABFB' : '#999090'}
                        />
                        <path
                          d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                          fill={sortStatusIcon ? '#00ABFB' : '#999090'}
                        />
                        <path
                          d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                          fill={sortStatusIcon ? '#00ABFB' : '#999090'}
                        />
                      </svg>
                    </th>

                    <th colSpan="6"></th>
                  </tr>
                </thead>

                {/* ____________ user Data Listing _____________ */}
                {isLoading ? (
                  <tbody>
                    <tr>
                      <td
                        colSpan="7"
                        style={{
                          textAlign: 'center',
                          padding: '20px',
                          fontSize: '15px',
                          fontFamily: 'IBM Plex Sans',
                        }}
                      >
                        Loading...
                      </td>
                    </tr>
                  </tbody>
                ) : (
                  <tbody>
                    {orgList?.results?.map((item, i) => (
                      <tr key={i} className={style.table_body_content}>
                        <td>
                          <div className={`${style.user_management_table_body_content} ${style.userFirstname}`}>
                            {item?.name}
                          </div>
                        </td>

                        <td colSpan="">
                          <div
                            style={{
                              position: 'relative',
                              top: item?.organization_admin?.length > 4 ? '20px !important' : '0px',
                            }}
                            className={`${style.user_management_table_body_content} ${style.adminOrg}`}
                          >
                            <span style={{ width: 'auto' }}>
                              {item?.organization_admin[0] ? (
                                item?.organization_admin?.slice(0, 4).join(', ')
                              ) : (
                                <span className="blankSpan">-</span>
                              )}

                              {item?.organization_admin?.length > 4 ? (
                                <span
                                  style={{ width: '16%', cursor: 'pointer' }}
                                  title={`${item?.organization_admin?.slice(4, item?.organization_admin.length).join(', ')}`}
                                >
                                  <span className={style.que_bank_count}>
                                    +{item?.organization_admin?.slice(4, item?.organization_admin.length).length}
                                  </span>
                                </span>
                              ) : (
                                ''
                              )}
                            </span>
                          </div>
                        </td>
                        <td>
                          <div className={`${style.user_management_table_body_content} ${style.userLasttname}`}>
                            {item?.no_of_users}
                          </div>
                        </td>
                        <td>
                          <div className={`${style.user_management_table_body_content} ${style.userOrganization}`}>
                            {item?.no_of_questions}
                          </div>
                        </td>

                        <td>
                          <div
                            className={`${item?.is_active ? `${style.activate}` : `${style.inactive}`} ${style.userStatus}`}
                          >
                            {' '}
                            <span>{item?.is_active ? 'Active' : 'Inactive'}</span>
                          </div>
                        </td>
                        <td></td>
                        <td></td>

                        <td className={style.user_detail_arrow}>
                          <div
                            className={` ${style.action} ${style.pointer}`}
                            onClick={() => {
                              dispatch(GetOraganisationDetails(item.id));
                              navigate(`/organization-management/details/${item.id}`);
                            }}
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M6.62891 3.39766L12.0622 8.83099C12.7039 9.47266 12.7039 10.5227 12.0622 11.1643L6.62891 16.5977"
                                stroke="#212529"
                                strokeWidth="1.5"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </table>
            </div>
          ) : (
            <>
              {!isLoading && orgList.error ? (
                <div className={style.noData}>
                  <div className={style.noDataText}>
                    No Results Found. We couldn&apos;t find anything that matches your search. Please try using
                    different keywords
                  </div>
                </div>
              ) : (
                <div
                  colSpan="7"
                  style={{
                    textAlign: 'center',
                    padding: '20px',
                    fontSize: '15px',
                    fontFamily: 'IBM Plex Sans',
                  }}
                >
                  Loading...
                </div>
              )}
            </>
          )}
        </div>
        {/*______________________________ PAGINATION ______________________________  */}
        <div className={`${style.user_paginationWrap}`}>
          {totalCount !== 0 && (
            <Pagination
              totalCount={totalCount}
              limit={limit}
              currentPage={currentPage}
              inputPage={inputPage}
              offset={offset}
              last={last}
              nextUrl={orgList.next}
              prevUrl={orgList.previous}
              setOffset={setOffset}
              setCurrentPage={setCurrentPage}
              setInputPage={setInputPage}
              setLast={setLast}
            />
          )}
        </div>

        {/*______________________________ PAGINATION ______________________________  */}
      </div>
      <FilterModal
        isOpen={modalFilter}
        statusValue={statusValue}
        setStatusValue={setStatusValue}
        filterValue={filterValue}
        setFilterValue={setFilterValue}
        // onSelectChange
        onClose={setModalFilter}
        onConfirm={handleFilter}
        data={{}}
        isDuplicatePreview={false}
      />
    </div>
  );
};

OrganisationList.propTypes = {
  UserData: PropTypes.any,
  setKeyword: PropTypes.func,
  setScreen: PropTypes.any,
  setid: PropTypes.any,
  setsort: PropTypes.func,
};

export default OrganisationList;
